import UltMeta, { Meta } from "@/meta/UltMeta/index";

class WaybillInfoTabs extends UltMeta {
    BASE_INFO = new Meta(1, "基本信息");
    PICKUP = new Meta(3, "装货");
    SAIL = new Meta(4, "发航");
    TRANSPORT = new Meta(5, "运输");
    UPLOAD = new Meta(6, "卸货");
}
export const WAYBILL_INFO_TABS = new WaybillInfoTabs();

class WayBillState extends UltMeta {
    PENDING_DEPOSIT = new Meta(10, "待付定金");
    AWAITING_DEPARTURE = new Meta(3, "待发航");
    DURING_TRANSPORTATION = new Meta(4, "运输中");
    TO_BE_UNLOADED = new Meta(5, "待卸货");
    COMPLETED = new Meta(8, "已完成");
    UNCOMPLETED = new Meta(13, "未完成");
}
export const WAYBILL_STATE = new WayBillState();

class WayBillType extends UltMeta {
    PLATFORM_CREATION = new Meta(1, "平台创建");
    SHIP_OWNER_TAKES_ORDERS = new Meta(2, "船主报价");
    SHIP_AGENT_TAKES_ORDERS = new Meta(3, "船代报价");
}
export const WAYBILL_TYPE = new WayBillType();

class GearShiftType extends UltMeta {
    UPPER_GEAR = new Meta(0, "上档");
    GEAR_SHIFT = new Meta(1, "接档");
    MAKE_FILE = new Meta(2, "让档");
}
export const GEARSHIFT_TYPE = new GearShiftType();

class IsDrain extends UltMeta {
    DRAIN = new Meta(1, "是");
    NOT_DRAIN = new Meta(0, "否");
}
export const IS_DRAIN = new IsDrain();

class FreightSettleTonConfirmNode extends UltMeta {
    AWAITING_DEPARTURE = new Meta(1, "待发航");
    TO_BE_UNLOADED = new Meta(2, "待卸货");
}
export const FREIGHT_SETTLE_TON_CONFIRM_NODE = new FreightSettleTonConfirmNode();

class MaritimeExpensesOptions extends UltMeta {
    SHIPPERS_BEAR_UPSTREAM = new Meta(1, "货主承担上游");
    SHIPPERS_BEAR_DOWNSTREAM = new Meta(2, "货主承担下游");
    SHIPPERS_BEAR_BOTH_PORTS = new Meta(3, "货主承担两港");
    SHIPPERS_NOT_RESPONSIBLE = new Meta(4, "货主不承担");
}

export const MARITIME_EXPENSES_OPTIONS = new MaritimeExpensesOptions();

class PaymentStatus extends UltMeta {
    UNPAID = new Meta(1, "未支付");
    UN_CONFIRM = new Meta(2, "待确认");
    SUCCESS = new Meta(3, "已支付");
}
export const PAYMENT_STATUS = new PaymentStatus();

class PayType extends UltMeta {
    ONLINE = new Meta(1, "线上");
    OFFLINE = new Meta(2, "线下");
}
export const PAY_TYPE = new PayType();

// 船运单类型
class ShipWayBillType extends UltMeta {
    SUPERVISION = new Meta(1, "服务运单");
    MATCHING = new Meta(2, "撮合运单");
}
export const SHIP_WAY_BILL_TYPE = new ShipWayBillType();

class ExpandCollapseType extends UltMeta {
    EXPAND = new Meta(1, "展开");
    COLLAPSE = new Meta(2, "收起");
}
export const EXPAND_COLLAPSE_TYPE = new ExpandCollapseType();

class OwnerCaptainState extends UltMeta {
    OWNER_UNPAID = new Meta(1, "货主未支付");
    OWNER_CONFIRMING = new Meta(2, "货主待确认");
    OWNER_SUCCESS = new Meta(3, "货主已支付");
    CAPTAIN_UNPAID = new Meta(4, "船主未支付");
    CAPTAIN_CONFIRMING = new Meta(5, "船主待确认");
    CAPTAIN_SUCCESS = new Meta(6, "船主已支付");
}
export const OWNER_CAPTAIN_STATE = new OwnerCaptainState();

/**
 * 签好运支付状态枚举
 */
class QhyPaymentState extends UltMeta {
    TO_BE_RECONCILIATION = new Meta(1, "待对账");
    WAIT_PAY = new Meta(2, "待支付");
    HAS_RECEIVED = new Meta(3, "已到账");
    PAY_FAIL = new Meta(4, "支付失败");
    APPLY_AUDITING = new Meta(5, "待审核");
    PAYING = new Meta(6, "支付中");
    HAS_INVALID = new Meta(7, "已作废");
    REJECTED = new Meta(8, "已拒绝");
}
export const QHY_PAYMENT_STATE = new QhyPaymentState();

class OwnerShippingDepositTypeQHY extends UltMeta {
    DEPOSIT_ONE = new Meta(1, "定金1", 10);
    DEPOSIT_TWO = new Meta(2, "定金2", 12);
    DEPOSIT_THREE = new Meta(3, "定金3", 14);
    BALANCE_PAYMENT = new Meta(4, "尾款", 30);
    DEPARTURE_FEE = new Meta(5, "出航费", 20);
    DEMURRAGE = new Meta(6, "滞期费", 40);
    DEPOSIT = new Meta(7, "定金", 88);
    FREIGHT = new Meta(8, "运费", 99);
}

export const OWNER_SHIPPING_DEPOSIT_TYPE_QHY = new OwnerShippingDepositTypeQHY();


class AuditOpinion extends UltMeta {
    AGREE = new Meta(2, "同意");
    REJECT = new Meta(3, "拒绝");
}

export const AUDIT_OPINION = new AuditOpinion();


class ReviewState extends UltMeta {
    UNDER_REVIEW = new Meta(1, "审核中");
    PASS = new Meta(2, "通过");
    REJECT = new Meta(3, "拒绝");
}

export const REVIEW_STATE = new ReviewState();